import React, { useState } from 'react'
import { IInputProps } from '../../../types/interfaces/IInputProps'
import { DatePickerContainer } from './style'
import { Label } from '../input/style'
import { Error } from '../error/Error'
import { DatePicker } from 'antd'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import locale from 'antd/es/date-picker/locale/he_IL'

dayjs.extend(utc)
locale.lang.shortWeekDays = ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש']
locale.lang.shortMonths = [
  'ינואר',
  'פברואר',
  'מרץ',
  'אפריל',
  'מאי',
  'יוני',
  'יולי',
  'אוגוסט',
  'ספטמבר',
  'אוקטובר',
  'נובמבר',
  'דצמבר',
]

export const DatePickerWrapper: React.FC<IInputProps> = ({
  callback,
  hasError,
  labelText,
  errorText,
  className,
  value,
  disabled,
  isRequired,
}) => {
  const [date, setDate] = useState<dayjs.Dayjs | null>(
    value ? dayjs(value, 'YYYY-MM-DD') : null,
  )
  const handleChange = (newDate: dayjs.Dayjs | null) => {
    setDate(newDate)
    if (newDate) {
      const adjustedDate = newDate.add(newDate.utcOffset(), 'minute')
      callback(adjustedDate, false)
    } else {
      callback('', true)
    }
  }

  return (
    <DatePickerContainer
      className={`date-picker-wrapper ${className ?? ''} ${
        hasError ? 'error' : ''
      }`}
    >
      <Label>
        {isRequired && <span style={{ color: 'red' }}>*</span>}
        {labelText}
      </Label>
      <DatePicker
        locale={locale}
        disabled={disabled ?? false}
        className={`date-picker ${className ?? ''} `}
        value={date}
        placeholder="DD.MM.YYYY"
        format="DD.MM.YYYY"
        onChange={handleChange}
        showTime={false}
        picker="date"
        allowClear={false}
        placement="bottomRight"
        popupClassName="date-picker-popup"
        defaultPickerValue={dayjs('1980-01-01', 'YYYY-MM-DD')}
        disabledDate={(current) =>
          current && current.isAfter(dayjs().endOf('day'))
        }
      />
      <Error hasError={hasError} errorText={errorText}></Error>
    </DatePickerContainer>
  )
}
